export interface LabelNameMap {
    key: string;
    title: string;
}

export const firstStepLabelMap: Record<string, LabelNameMap> = {

};

export const secondStepLabelMap: Record<string, LabelNameMap> = {
    toileting: {
        key: 'toileting',
        title: 'TOILETING'
    },
    personalHygiene: {
        key: 'personalHygiene',
        title: 'PERSONAL_HYGIENE'
    },
    dressing: {
        key: 'dressing',
        title: 'DRESSING'
    },
    footwearManagement: {
        key: 'footwearManagement',
        title: 'FOOTWEAR_MANAGEMENT'
    },
    eating: {
        key: 'eating',
        title: 'EATING'
    },
    medicationManagement: {
        key: 'medicationManagement',
        title: 'MEDICATION_MANAGEMENT'
    }
};
 
export const thirdStepLabelMap: Record<string, LabelNameMap> = {
    publicTransportUse: {
        key: 'publicTransportUse',
        title: 'PUBLIC_TRANSPORT_USE'
    },
    publicServicesUse: {
        key: 'publicServicesUse',
        title: 'PUBLIC_SERVICES_USE'
    },
    moneyManagement: {
        key: 'moneyManagement',
        title: 'MONEY_MANAGEMENT'
    },
    shopping: {
        key: 'shopping',
        title: 'SHOPPING'
    },
    environmentalHygiene: {
        key: 'environmentalHygiene',
        title: 'ENVIRONMENTAL_HYGIENE'
    },
    workOrEducationEngagement: {
        key: 'workOrEducationEngagement',
        title: 'WORK_OR_EDUCATION_ENGAGEMENT'
    },
    foodPreparation: {
        key: 'foodPreparation',
        title: 'FOOD_PREPARATION'
    },
    phoneUse: {
        key: 'phoneUse',
        title: 'PHONE_USE'
    },
    spatialOrientation: {
        key: 'spatialOrientation',
        title: 'SPATIAL_ORIENTATION'
    }
};

export const fourthStepLabelMap: Record<string, LabelNameMap> = {
    ruleCompliance: {
        key: 'ruleCompliance',
        title: 'RULE_COMPLIANCE'
    },
    communication: {
        key: 'communication',
        title: 'COMMUNICATION'
    },
    peerRelationship: {
        key: 'peerRelationship',
        title: 'PEER_RELATIONSHIP'
    },
    socialRelationship: {
        key: 'socialRelationship',
        title: 'SOCIAL_RELATIONSHIP'
    },
    familyRelationshipMaintenance: {
        key: 'familyRelationshipMaintenance',
        title: 'FAMILY_RELATIONSHIP_MAINTENANCE'
    },
    communityActivityParticipation: {
        key: 'communityActivityParticipation',
        title: 'COMMUNITY_ACTIVITY_PARTICIPATION'
    },
    riskAvoidance: {
        key: 'riskAvoidance',
        title: 'RISK_AVOIDANCE'
    },
    aggressiveness: {
        key: 'aggressiveness',
        title: 'AGGRESSIVNESS'
    },
    temporalOrientation: {
        key: 'temporalOrientation',
        title: 'TEMPORAL_ORIENTATION'
    }
};

export const fifthStepLabelMap: Record<string, LabelNameMap> = {
    homeMobility: {
        key: 'homeMobility',
        title: 'HOME_MOBILITY'
    },
    outdoorMobility: {
        key: 'outdoorMobility',
        title: 'OUTDOOR_MOBILITY'
    }
};